import React, { useState, useEffect } from 'react';
import Icon, { COLORS, ICONS } from './icon';

//this is its own functional component to prevent re-rendering a redux component every second
interface Props {startTime?: Date}
export default function Clock(props: Props) {
	const [currentTime, setCurrentTime] = useState(new Date());
	const [margin, setMargin] = useState<React.CSSProperties>({marginLeft: 0});
	let clockInterval: NodeJS.Timeout;

	const checkHasStarted = (now: Date, start?: Date) => {
		if (start && start < now) {
			setMargin({marginLeft: '16px'});
		} else {
			setMargin({marginLeft: 0});
		}
	}

	const updateClock = (start?: Date) => {
		clockInterval = setInterval(() => {
			setCurrentTime(new Date());
			checkHasStarted(new Date(), start);
		}, 1000)
	}

	useEffect(() => {
		updateClock(props.startTime);
		return () => { clearInterval(clockInterval); }
	}, [props.startTime])

	return (
		<div className="clock" style={margin}>
			<p className="header-time">
				<Icon name={ICONS.CLOCK} color={COLORS.WHITE} size={14} />
				{currentTime.toLocaleString("en-US", { hour: 'numeric', minute: 'numeric', second: 'numeric' })}
			</p>
		</div>

	)
}